import { takeEvery, put, call, select, all } from "redux-saga/effects"

import {
  // CONTROL PLANS
  GET_PLANS_CONTROL,
  GET_ALL_CONTROL_PLANS_AND_CONTROLS,
  PATCH_PLAN_CONTROL,
  POST_PLAN_CONTROL,
  DELETE_PLAN_CONTROL,
  DUPLICATE_PLAN_CONTROL,
  // CONTROLS
  GET_ALL_CONTROLS,
  PATCH_CONTROL_FROM_PLANNING_CONTROL,
  GET_CONTROL_PLAN_AND_CONTROLS,
  GET_CONTROL_AND_TEMPLATE_BY_ID,
  POST_CONTROL,
  PATCH_CONTROL_99,
  AFFECT_USERS_CONTROL,
  DELETE_CONTROL,
  DUPLICATE_CONTROL,
  GET_CONTROLS_THAT_HAVE_RECOMMENDATIONS,
  GET_OVERALL_SYNTHESE_CONTROL,
  // FILES
  POST_FILES_CONTROL,
  DELETE_FILES_CONTROL,
  // CONTROL POINTS
  DUPLICATE_CONTROL_POINT,
  PATCH_CONTROL_POINT,
  DELETE_CONTROL_POINT,
  // CONTROL THREAD
  GET_CONTROL_THREAD_BY_CONTROL_ID,
  POST_MESSAGE_CONTROL_THREAD,
  // CONTROL PARAMETERS AND TEMPLATE VALIDATION WORFKLOW 99
  CONFIRM_CONTROL_VALIDATION,
  // VALIDATION CONTROLS
  MANAGER_VALID_CONTROL,
  MANAGER_REJECT_CONTROL,
  CLIENT_VALID_CONTROL,
  CLIENT_REJECT_CONTROL,
  // ALL DATAS CONTROL PLANNING
  GET_ALL_DATAS_CONTROL_PLANNING_V2,
} from "./constants"

import {
  responseTypeIsError,
  responseTypeIsSuccess,
  manageErrorGenerator,
  manageSuccessGenerator,
} from "Containers/App/saga"

// Utils
import request, { requestFilesAndDownload } from "Utils/request"
import { loadSagaTranslation } from "Utils/sagaTranslation"
import { config } from "Utils/config"
import { getCors, postCors, patchCors, deleteCors } from "Utils/rulesCors"
import {
  getFilterControlPlansNotArchived,
  getControlReadyToPatch,
  getNotifUsersAffectedToControl,
  getNotifUsersAffectedToControlPlan,
  getNotifPatchControlPlanAssign,
} from "./utils"
// Actions
import { getRecommendationsAction } from "ContainersForm/Recommendations/actions"
import { postNotificationAction } from "Containers/Notifications/actions"
import { getPreparedCardsPlanningAction } from "ContainersForm/DisplayForm/actions.js"
import {
  getControlPlanAndControlsAction,
  getAllControlPlansAndControlsSuccessAction,
  getPlansControlSuccessAction,
  getAllControlPlansAndControlsAction,
  postFilesControlSuccessAction,
  getControlPlanAndControlsuccessAction,
  deleteFilesControlSuccessAction,
  getControlAndTemplateByIdSuccessAction,
  getControlsThatHaveRecommendationsSuccessAction,
  getControlThreadByControlIdAction,
  getControlThreadByControlIdSuccessAction,
  setIsLoadingControlAction,
  getOverallSyntheseControlSuccessAction,
  setIsLoadingSyntheseAction,
  getControlAndTemplateByIdAction,
} from "./actions"
import { setErrorMessage } from "Containers/Messages/actions"
import { getTemplateByTypeAction } from "ContainersForm/Templates/actions.js"
import { getResponseByIdAction } from "ContainersForm/Responses/actions.js"

// Selectors
import {
  selectCurrentToken,
  selectCurrentUser,
  selectLangageID,
} from "Containers/Login/selectors.js"
import { selectBusinessTag } from "Containers/BusinessInformations/selectors.js"

// Others sagas
import { postFileToS3 } from "ContainersForm/ETL/saga.js"
import { getResponsesByIdSaga } from "ContainersForm/DisplayForm/saga.js"
import { getDocumentsAssociateResponse } from "ContainersForm/DocumentManagement/saga.js"
import { generateTemplateNotification } from "Components/Notifications/utils"

//************************************************ */
//**************CONTROL PLANS************** */
//************************************************ */

export function* getAllPlanControl() {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = "controlPlans"
  const requestURL = `${FORM_BACK_URL}/${endPath}`
  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getPlansControlSuccessAction(response.body))
        return response?.body
      }
    }
  } catch (err) {
    console.error(`[route] => /${endPath} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

function* postPlanControl({ payload }) {
  const { controlPlan } = payload
  const currentUser = yield select(selectCurrentUser)
  const trad = yield call(loadSagaTranslation, currentUser?.LANGUAGE_ID)
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = "controlPlans"
  const requestURL = `${FORM_BACK_URL}/${endPath}`

  try {
    const response = yield call(request, requestURL, postCors(controlPlan, specificHeaders))

    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getAllControlPlansAndControlsAction())
        const notif = getNotifUsersAffectedToControlPlan(
          currentUser,
          trad,
          controlPlan,
          response?.body?.newId
        )
        const infos_notif = generateTemplateNotification("control_plan_assignment", {
          notif,
          currentUser,
          trad,
          newId: response?.body?.newId,
        })
        yield put(postNotificationAction({ notif, infos_notif }))
      }
    }
  } catch (err) {
    console.error(`[route] => /${endPath} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

function* patchPlanControl({ payload }) {
  const { controlPlan, newResponsiblesAffected } = payload
  const currentUser = yield select(selectCurrentUser)
  const trad = yield call(loadSagaTranslation, currentUser?.LANGUAGE_ID)
  const planControlId = controlPlan?._id?.$oid

  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = `controlPlans/${planControlId}`
  const requestURL = `${FORM_BACK_URL}/${endPath}`

  try {
    const response = yield call(request, requestURL, patchCors(controlPlan, specificHeaders))

    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
        yield put(getAllControlPlansAndControlsAction())
        if (newResponsiblesAffected?.length > 0) {
          const notif = getNotifPatchControlPlanAssign(
            currentUser,
            trad,
            controlPlan,
            newResponsiblesAffected,
            payload?.controlPlan?._id?.$oid
          )
          const infos_notif = generateTemplateNotification("control_plan_assignment", {
            notif,
            currentUser,
            trad,
            newId: payload?.controlPlan?._id?.$oid,
          })
          yield put(postNotificationAction({ notif, infos_notif }))
        }
      }
    }
  } catch (err) {
    console.error(`[route] => /${endPath} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

function* deletePlanControl({ payload }) {
  const { controlPlanId, action } = payload
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = `controlPlans/${controlPlanId}?action=${action}`
  let requestURL = `${FORM_BACK_URL}/${endPath}`

  try {
    const response = yield call(request, requestURL, deleteCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      yield put(getAllControlPlansAndControlsAction())
    }
  } catch (error) {
    console.error(`[route] => /${endPath} => ERROR => `, error)
    yield put(setErrorMessage(error))
  }
}

function* duplicatePlanControl({ payload }) {
  const { controlPlan } = payload
  const currentUser = yield select(selectCurrentUser)
  const trad = yield call(loadSagaTranslation, currentUser?.LANGUAGE_ID)
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = `duplicateControlPlan/${controlPlan?._id?.$oid}`
  const requestURL = `${FORM_BACK_URL}/${endPath}`

  try {
    const response = yield call(request, requestURL, postCors({}, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getAllControlPlansAndControlsAction())
        const notif = getNotifUsersAffectedToControlPlan(currentUser, trad, controlPlan)
        const infos_notif = generateTemplateNotification("control_plan_assignment", {
          notif,
          currentUser,
          trad,
        })
        yield put(postNotificationAction({ notif, infos_notif }))
      }
    }
  } catch (error) {
    console.error(`[route] => /${endPath} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

//************************************************ */
//**************CONTROLES WITH FILES************** */
//************************************************ */
function* getAllControlPlansAndControls() {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = `controlPlansAndControls`
  const requestURL = `${FORM_BACK_URL}/${endPath}`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      // FILTER CONTROL PLANS NOT ARCHIVED
      const controlPlansNotArchived = getFilterControlPlansNotArchived(response.body)
      yield put(getAllControlPlansAndControlsSuccessAction(controlPlansNotArchived))
    }
  } catch (err) {
    console.error(`[route] => /${endPath} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

function* getControlPlanAndControls({ payload }) {
  const controlPlanId = payload
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = `controlPlanAndControls/${controlPlanId}`
  const requestURL = `${FORM_BACK_URL}/${endPath}`
  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      yield put(getControlPlanAndControlsuccessAction(response.body))
    }
  } catch (err) {
    console.error(`[route] => /${endPath} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

function* getControlAndTemplateById({ payload }) {
  const { controlId, queryIsoDate } = payload
  const businessTag = yield select(selectBusinessTag)

  const token = yield select(selectCurrentToken)
  const myLanguageId = yield select(selectLangageID)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = `v2/controlandtemplateById/${controlId}`
  const languageIdQuery = `languageId=${myLanguageId}`
  let requestURL = `${FORM_BACK_URL}/${endPath}?${languageIdQuery}`

  if (queryIsoDate && businessTag === "csf") {
    const dateQuery = `&date=${queryIsoDate}`
    requestURL += dateQuery
  }
  try {
    yield put(setIsLoadingControlAction(true))
    const response = yield call(request, requestURL, postCors({}, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      yield put(getControlAndTemplateByIdSuccessAction(response.body))
      yield put(setIsLoadingControlAction(false))
    }
  } catch (err) {
    console.error(`[route] => /${endPath} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

function* postControl({ payload }) {
  const { control } = payload
  const controlPlanId = control?.controlPlanId
  const affectedUsersIds = control?.targetUsers?.usersIds
  const currentUser = yield select(selectCurrentUser)
  const token = yield select(selectCurrentToken)
  const trad = yield call(loadSagaTranslation, currentUser?.LANGUAGE_ID)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = `saveDraftControl`
  const requestURL = `${FORM_BACK_URL}/${endPath}`

  try {
    const response = yield call(request, requestURL, postCors({ control }, specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageSuccessGenerator, { response, showMessageToUser: true })
    } else if (responseTypeIsSuccess(response)) {
      yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      yield put(getControlPlanAndControlsAction(controlPlanId))
      if (affectedUsersIds && affectedUsersIds?.length > 0) {
        const notif = getNotifUsersAffectedToControl(currentUser, trad, control)
        const payload = { controlPlanId }
        const infos_notif = generateTemplateNotification("control_assignment", {
          notif,
          currentUser,
          payload,
          trad,
        })
        yield put(postNotificationAction({ notif, infos_notif }))
      }
    }
  } catch (err) {
    console.error(`[route] => /${endPath} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

function* patchControl99Advisory({ payload }) {
  const { control } = payload
  const businessTag = yield select(selectBusinessTag)
  const controlToPatch = getControlReadyToPatch(control, businessTag)
  const controlPlanId = control?.controlPlanId
  const controlId = controlToPatch?._id?.$oid

  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = `control/${controlId}`
  const requestURL = `${FORM_BACK_URL}/${endPath}`

  try {
    const response = yield call(request, requestURL, patchCors(controlToPatch, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageSuccessGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      yield put(getControlPlanAndControlsAction(controlPlanId))
    }
  } catch (err) {
    console.error(`[route] => /${endPath} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

function* patchControlFromPlanningControl({ payload }) {
  const businessTag = yield select(selectBusinessTag)
  const token = yield select(selectCurrentToken)

  const controlToPatch = getControlReadyToPatch(payload, businessTag)
  const controlId = controlToPatch?._id?.$oid

  try {
    const response = yield call(
      request,
      `${config?.FORM_BACK_URL}/control/${controlId}`,
      patchCors(controlToPatch, { token })
    )

    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: false })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(
          getTemplateByTypeAction({ filterparam: "frommybusiness", format: "controlsAndTemplates" })
        )
      }
    }
  } catch (err) {
    console.error(`[route] => /control/${controlId} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

function* affectUsersControl({ payload }) {
  const { controlAffected } = payload
  const currentUser = yield select(selectCurrentUser)
  const token = yield select(selectCurrentToken)
  const trad = yield call(loadSagaTranslation, currentUser?.LANGUAGE_ID)
  const controlId = controlAffected?._id?.$oid
  const controlPlanId = controlAffected?.controlPlanId
  const bodyToSend = {
    history: controlAffected?.history,
    targetUsers: controlAffected?.targetUsers,
  }

  try {
    const response = yield call(
      request,
      `${config?.FORM_BACK_URL}/affectUserToControl/${controlId}`,
      patchCors(bodyToSend, { token: token })
    )

    if (responseTypeIsError(response)) {
      yield call(manageSuccessGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getControlPlanAndControlsAction(controlPlanId))
        const notif = getNotifUsersAffectedToControl(currentUser, trad, controlAffected)
        const payload = { controlPlanId }
        const infos_notif = generateTemplateNotification("control_assignment", {
          notif,
          currentUser,
          payload,
          trad,
        })
        yield put(postNotificationAction({ notif, infos_notif }))
      }
    }
  } catch (err) {
    console.error(`[route] => /affectUserToControl/${controlId} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

function* deleteControl({ payload }) {
  const { controlPlanId, controlId, action } = payload
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = `control/${controlId}?action=${action}`
  const requestURL = `${FORM_BACK_URL}/${endPath}`

  try {
    const response = yield call(request, requestURL, deleteCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageSuccessGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      yield put(getControlPlanAndControlsAction(controlPlanId))
    }
  } catch (err) {
    console.error(`[route] => /${endPath} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

function* duplicateControl({ payload }) {
  const controlPlanId = payload?.controlPlanId
  const controlId = payload?.controlId
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = `duplicateControl/${controlId}`
  const requestURL = `${FORM_BACK_URL}/${endPath}`

  try {
    const response = yield call(request, requestURL, postCors({}, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageSuccessGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      yield put(getControlPlanAndControlsAction(controlPlanId))
    }
  } catch (err) {
    console.error(`[route] => /${endPath} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

function* getControlsThatHaveRecommendations() {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = `controlsThatHaveRecommendations`
  const requestURL = `${FORM_BACK_URL}/${endPath}`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageSuccessGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getControlsThatHaveRecommendationsSuccessAction(response.body))
      }
    }
  } catch (err) {
    console.error(`[route] => /${endPath} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

function* getOverallSyntheseControl({ payload }) {
  const { controlId } = payload
  const token = yield select(selectCurrentToken)
  const myLanguageId = yield select(selectLangageID)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = `overallSummaryOfControl/${controlId}`
  const languageIdQuery = `languageId=${myLanguageId}`
  const requestURL = `${FORM_BACK_URL}/${endPath}?${languageIdQuery}`

  try {
    yield put(setIsLoadingSyntheseAction(true))
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageSuccessGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getOverallSyntheseControlSuccessAction(response.body))
        yield put(setIsLoadingSyntheseAction(false))
      }
    }
  } catch (err) {
    console.error(`[route] => /${endPath} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

//************************************************ */
// CONTROL PARAMETERS AND TEMPLATE VALIDATION WORFKLOW 99 */
//************************************************ *

// Pour cette saga on triche un peu, on appelle une route qui servait à savoir si le consultant avait des
// modifications a enregistrer temporairement, maintenant le consultant peut modifier "en direct" le contrôle
// et le template ( comme le manager) donc on valide simplement le contrôle pour qu'il passe dans un état
// "prêt a répondre".
function* confirmControl99Advisory({ payload }) {
  const { controlId, controlPlanId, notification, infos_notif } = payload
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = `consultantModifyControl`
  const requestURL = `${FORM_BACK_URL}/${endPath}`

  const body = {
    controlId,
    action: "consultantHasNoModification",
  }

  try {
    const response = yield call(request, requestURL, patchCors(body, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageSuccessGenerator, { response, showMessageToUser: true })
    else {
      yield call(manageSuccessGenerator, { response, showMessageToUser: true })
      yield put(getControlPlanAndControlsAction(controlPlanId))
      if (notification) {
        yield put(postNotificationAction({ notif: notification, infos_notif }))
      }
    }
  } catch (err) {
    console.error(`[route] => /${endPath} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

//************************************************ */
//**************       FILES    ****************** */
//************************************************ *

function* postFilesControl({ payload }) {
  const newFile = payload?.file

  try {
    const response = yield call(postFileToS3, newFile)
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      const newFilePosted = {
        name: response?.body?.name,
        uuid: response?.body?.uuid,
      }
      yield put(postFilesControlSuccessAction(newFilePosted))
    }
  } catch (err) {
    console.error(`[route] => ERROR POST PIECES JOINTES CONTROL => `, err)
    yield put(setErrorMessage(err))
  }
}

function* deleteFileControl({ payload }) {
  const fileName = payload?.fileName

  const token = yield select(selectCurrentToken)

  const specificHeaders = { token: token }

  const { API_URL } = config
  const endPath = `/v1/files/${fileName}`
  const requestURL = `${API_URL}${endPath}`

  try {
    const response = yield call(request, requestURL, { ...deleteCors(specificHeaders) })
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      yield put(deleteFilesControlSuccessAction(fileName))
    }
  } catch (err) {
    console.error(`[route] => ${endPath} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

//************************************************ */
//**************CONTROLES POINTS****************** */
//************************************************ */

function* duplicateControlPoint({ payload }) {
  const token = yield select(selectCurrentToken)

  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { templateId, controlId, sectionId } = payload
  const requestURL = `${FORM_BACK_URL}/duplicateTemplateSection/${templateId}/${sectionId}`

  try {
    const response = yield call(request, requestURL, postCors(specificHeaders))
    console.log("reponse", response)
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getControlAndTemplateByIdAction({ controlId }))
      }
    }
  } catch (err) {
    console.error(
      "[route] => /duplicateTemplateSection/:templateId/:sectionId  => PATCH => ERROR => ",
      err
    )
    yield put(setErrorMessage(err))
  }
}

function* deleteControlPoint({ payload }) {
  const token = yield select(selectCurrentToken)

  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { templateId, controlId, sectionId } = payload
  const requestURL = `${FORM_BACK_URL}/deleteTemplateSection/${templateId}/${sectionId}`
  try {
    const response = yield call(request, requestURL, deleteCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getControlAndTemplateByIdAction({ controlId }))
      }
    }
  } catch (err) {
    console.error("[route] => /deleteTemplateSection/:templateId/:sectionId  => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

function* patchControlPoint({ payload }) {
  const token = yield select(selectCurrentToken)

  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const { data, controlId, type } = payload
  const requestURL = `${FORM_BACK_URL}/v2/updateTemplateByControlId/${controlId}/${type}`

  try {
    const response = yield call(request, requestURL, patchCors(data, specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getControlAndTemplateByIdAction({ controlId }))
      }
    }
  } catch (err) {
    console.error(
      "[route] => /v2/updateTemplateByControlId/:controlId/:type => PATCH => ERROR => ",
      err
    )
    yield put(setErrorMessage(err))
  }
}

//************************************************ */
//**************CONTROL THREADS****************** */
//************************************************ */
function* getControlThreadByControlId({ payload }) {
  const { controlId } = payload
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = `controlThreadByControlId/${controlId}`
  const requestURL = `${FORM_BACK_URL}/${endPath}`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      yield put(getControlThreadByControlIdSuccessAction(response.body?.messages))
    }
  } catch (err) {
    console.error(`[route] => /${endPath} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

function* postMessageToControlThread({ payload }) {
  const { controlId, newMessage, notifNewMessageInThread, infos_notif } = payload
  const bodyToSend = { controlId, newMessage }
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = `addMessageToControlThread`
  const requestURL = `${FORM_BACK_URL}/${endPath}`

  try {
    const response = yield call(request, requestURL, postCors(bodyToSend, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
      yield put(getControlThreadByControlIdAction({ controlId }))
      yield put(postNotificationAction({ notif: notifNewMessageInThread, infos_notif }))
    }
  } catch (err) {
    console.error(`[route] => /${endPath} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

//************************************************ */
//************** VALIDATION CONTROLS ***************/
//************************************************ */

function* managerValidControl({ payload }) {
  const { responseId, notifToValidControl, infos_notif } = payload
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = `managerValidateResponse/${responseId}`
  const requestURL = `${FORM_BACK_URL}/${endPath}`

  try {
    const response = yield call(request, requestURL, patchCors({}, specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      // Refresh for global planning and icon card
      yield put(getPreparedCardsPlanningAction())
      // Refresh for modal planning V2
      yield put(getResponseByIdAction({ responseId }))
      // Notif
      yield put(postNotificationAction({ notif: notifToValidControl, infos_notif }))
    }
  } catch (err) {
    console.error(`[route] => /${endPath} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

function* managerRejectControl({ payload }) {
  const { responseId, notifToRejectControl, infos_notif } = payload
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = `managerRejectResponse/${responseId}`
  const requestURL = `${FORM_BACK_URL}/${endPath}`

  try {
    const response = yield call(request, requestURL, patchCors({}, specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    } else {
      // Refresh for global planning and icon card
      yield put(getPreparedCardsPlanningAction())
      // Refresh for modal planning V2
      yield put(getResponseByIdAction({ responseId }))
      // Notif
      yield put(postNotificationAction({ notif: notifToRejectControl, infos_notif }))
    }
  } catch (err) {
    console.error(`[route] => /${endPath} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

function* clientValidControl({ payload }) {
  const { responseId, notifToValidControl, infos_notif } = payload
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = `clientValidateResponse/${responseId}`
  const requestURL = `${FORM_BACK_URL}/${endPath}`

  try {
    const response = yield call(request, requestURL, patchCors({}, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      // Refresh for modal planning V2
      yield put(getResponseByIdAction({ responseId }))
      // Refresh for global planning and icon card
      yield put(getPreparedCardsPlanningAction())
      // Notif
      yield put(postNotificationAction({ notif: notifToValidControl, infos_notif }))
      // Reco ready to be completed in icon layout
      yield put(getRecommendationsAction())
    }
  } catch (err) {
    console.error(`[route] => /${endPath} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

function* clientRejectControl({ payload }) {
  const { responseId, notifToRejectControl, infos_notif } = payload
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const endPath = `clientRejectResponse/${responseId}`
  const requestURL = `${FORM_BACK_URL}/${endPath}`

  try {
    const response = yield call(request, requestURL, patchCors({}, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      // Refresh for modal planning V2
      yield put(getResponseByIdAction({ responseId }))
      // Refresh for global planning and icon card
      yield put(getPreparedCardsPlanningAction())
      // Notif
      yield put(postNotificationAction({ notif: notifToRejectControl, infos_notif }))
    }
  } catch (err) {
    console.error(`[route] => /${endPath} => ERROR => `, err)
    yield put(setErrorMessage(err))
  }
}

// ALL DATAS CONTROL PLANNING
function* getAllDatasControlPlanningV2({ payload }) {
  const { controlId, responseId } = payload
  const newPayload = { payload: { controlId, responseId } }

  try {
    // we launch multiples call for others sagas directly, not actions.
    yield all([
      call(getControlAndTemplateById, newPayload),
      call(getControlThreadByControlId, newPayload),
      call(getResponsesByIdSaga, newPayload),
      call(getDocumentsAssociateResponse, newPayload),
    ])
    // Here it's started only when yield all call is over
    yield put(setIsLoadingControlAction(false))
  } catch (err) {
    console.error(`[route] => ERROR GET ALL DATAS CONTROL PLANNING DATA V2 `, err)
  }
}

function* planControlSaga() {
  // CONTROL PLANS
  yield takeEvery(GET_PLANS_CONTROL, getAllPlanControl)
  yield takeEvery(POST_PLAN_CONTROL, postPlanControl)
  yield takeEvery(PATCH_PLAN_CONTROL, patchPlanControl)
  yield takeEvery(DELETE_PLAN_CONTROL, deletePlanControl)
  yield takeEvery(DUPLICATE_PLAN_CONTROL, duplicatePlanControl)
  // CONTROLS
  yield takeEvery(GET_ALL_CONTROL_PLANS_AND_CONTROLS, getAllControlPlansAndControls)
  yield takeEvery(GET_CONTROL_PLAN_AND_CONTROLS, getControlPlanAndControls)
  yield takeEvery(GET_CONTROL_AND_TEMPLATE_BY_ID, getControlAndTemplateById)
  yield takeEvery(POST_CONTROL, postControl)
  yield takeEvery(PATCH_CONTROL_99, patchControl99Advisory)
  yield takeEvery(PATCH_CONTROL_FROM_PLANNING_CONTROL, patchControlFromPlanningControl)
  yield takeEvery(AFFECT_USERS_CONTROL, affectUsersControl)
  yield takeEvery(DELETE_CONTROL, deleteControl)
  yield takeEvery(DUPLICATE_CONTROL, duplicateControl)
  yield takeEvery(GET_CONTROLS_THAT_HAVE_RECOMMENDATIONS, getControlsThatHaveRecommendations)
  yield takeEvery(GET_OVERALL_SYNTHESE_CONTROL, getOverallSyntheseControl)
  // FILES
  yield takeEvery(POST_FILES_CONTROL, postFilesControl)
  yield takeEvery(DELETE_FILES_CONTROL, deleteFileControl)
  // CONTROLS POINTS
  yield takeEvery(DUPLICATE_CONTROL_POINT, duplicateControlPoint)
  yield takeEvery(PATCH_CONTROL_POINT, patchControlPoint)
  yield takeEvery(DELETE_CONTROL_POINT, deleteControlPoint)
  // CONTROL THREAD
  yield takeEvery(GET_CONTROL_THREAD_BY_CONTROL_ID, getControlThreadByControlId)
  yield takeEvery(POST_MESSAGE_CONTROL_THREAD, postMessageToControlThread)
  // CONTROL PARAMETERS AND TEMPLATE VALIDATION WORFKLOW 99
  yield takeEvery(CONFIRM_CONTROL_VALIDATION, confirmControl99Advisory)
  // VALIDATION CONTROLS
  yield takeEvery(MANAGER_VALID_CONTROL, managerValidControl)
  yield takeEvery(MANAGER_REJECT_CONTROL, managerRejectControl)
  yield takeEvery(CLIENT_VALID_CONTROL, clientValidControl)
  yield takeEvery(CLIENT_REJECT_CONTROL, clientRejectControl)
  // ALL DATAS CONTROL PLANNING
  yield takeEvery(GET_ALL_DATAS_CONTROL_PLANNING_V2, getAllDatasControlPlanningV2)
}

export default planControlSaga
